import React from "react"
import "./Residency.css"

const Parkresidency = () => {
  return (
    <div>
      <div className="residency">
        <div className="residency-top" data-aos="fade-right"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine">
          <img src="./ParkPhotos/Residency/residency.jpg" alt="building" />
        </div>
        <div className="residency-bottom" data-aos="fade-left"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine">
          <h3>WELCOME TO<br/>THE PARK <br/> AVENUE ONE</h3>
          <p>
            The Park by Avenue One is a premium residential project designed around comfort,
            privacy, greenery, and refined everyday living.
            Located in prestigious Springs Block (Egyptian Block) Bahria Town, Lahore The Park offers a
            calm residential environment with modern planning, secure access, lifestyle convenience, and a
            more private living experience. The project is designed for families, residential buyers, and
            investors looking for a premium address with generational wealth.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Parkresidency